import React from 'react';

// handleChange sets value and updates state of province

const PostalCode = (props) => {
	const validClass = (props.validation.isInvalid) ? "app__form-input--error" : "";

	return (
		<div className="app__form-group">
			<label htmlFor="emco_postalcode">
				{props.content.postalCode}
				<input 
					className={`app__form-input ${validClass}`} 
					type="text" 
					id="emco_postalcode" 
					name="postalcode" 
					autoCapitalize="none" 
					maxLength="7" 
					onChange={props.handleChange}/>
			</label>
			<div className="app__form--error">{props.validation.message}</div>
		</div>
	)
}

export default PostalCode;


// WEBPACK FOOTER //
// ./src/components/PostalCode.js